module.exports = __webpack_public_path__ + "static/img/category-prefix.3b35eaa8.svg";